module.exports = __webpack_public_path__ + "img/Dantam Hair 13.7bd539e8.jpg";